import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBlueFilter = function SvgBlueFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.696 18.019a.75.75 0 0 1 1.06-.05 4.818 4.818 0 0 0 6.489 0 .75.75 0 1 1 1.01 1.11 6.318 6.318 0 0 1-8.51 0 .75.75 0 0 1-.05-1.06ZM17.75 13.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75ZM22.25 13.25A.75.75 0 0 1 23 14v1.5a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.25 11.75A2.25 2.25 0 0 1 12.5 9.5h15a2.25 2.25 0 0 1 2.25 2.25V23a.75.75 0 0 1-.75.75H11a.75.75 0 0 1-.75-.75V11.75ZM12.5 11a.75.75 0 0 0-.75.75v10.5h16.5v-10.5a.75.75 0 0 0-.75-.75h-15Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.8 30.45H10.3c-.8 0-1.5-.4-1.9-1-.4-.6-.5-1.4-.2-2.1l2.1-4.6c.1-.3.4-.5.7-.5h18c.3 0 .6.2.7.4l2.1 4.6c.3.7.2 1.5-.2 2.1-.4.8-1.1 1.1-1.8 1.1Zm-18.3-6.7-1.9 4.2c-.1.2-.1.5 0 .7.2.2.4.4.7.4h19.5c.3 0 .5-.1.6-.3.1-.2.2-.5.1-.7l-2-4.3h-17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.75 26.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })));
};

export { SvgBlueFilter as default };
//# sourceMappingURL=blue-filter.svg.js.map
